import { useIntl } from "react-intl";
import useTitle from "./useTitle";

export default function useListTitle(labelId: string) {
  const { formatMessage } = useIntl();
  return useTitle(`${formatMessage({ id: labelId })} List`);
}
